import styled from 'styled-components'

export const Container = styled.div`
  border-radius: 0.5rem;
  border: 0.063rem solid var(--gray-200);
`

Container.displayName = 'Container'
